import React, { Component } from 'react'
import { connect } from 'react-redux'
import UserCard from '../components/usercard'

class LandingSideInfo extends Component {
    render() {
        return (
            <div className="col-12 col-md-4 order-1 order-sm-1 order-md-2 ml-auto ml-md-auto noMargin sideBox">
                {this.props.user == null ? <></> : <UserCard user={this.props.user} language={this.props.language} />}
                {/* {this.props.showPrint ? <PrintButton/> : <></>} */}
                <div className="alert sideInfo hideMobile">
                    <p>
                        {this.props.strings.LANDING_SIDE_ALERT_1}
                    </p>
                    <p>
                        <b>
                            {this.props.strings.LANDING_SIDE_ALERT_2}
                            <a href={this.props.strings.LANDING_SIDE_ALERT_2_LINK} target="_blank">
                                {this.props.strings.LANDING_SIDE_ALERT_2_LINK_TEXT}
                            </a>.
                        </b>
                    </p>
                </div>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        user: state.api.user,
        strings: state.language.strings,
        language: state.language.language,
        showPrint: ownProps.showPrint
    }
}

const ConnectedLandingSideInfo = connect(
    mapStateToProps
)(LandingSideInfo);
export default ConnectedLandingSideInfo;
